import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 22.72 20.01' {...props}>
    <g data-name='Layer 2'>
      <path
        fill='undefined'
        d='M9.98 2.44l6.11 5.88H0v3.38h16.09l-6.11 5.88 2.35 2.43 10.39-10L12.33 0 9.98 2.44z'
        data-name='Layer 1'
      />
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/ArrowIcon.js